import React from 'react';

type ActivityStatus = 'active' | 'low_activity' | 'inactive' | 'not_yet_installed';
type WorkspaceWarning = 'missing_from_source' | 'suspended' | null;

interface UserStatusIconsProps {
  activityStatus?: ActivityStatus | string | null;
  activityStatusTooltip?: string | null;
  workspaceWarning?: WorkspaceWarning | string | null;
  workspaceWarningTooltip?: string | null;
}

const circleColor = (status?: string | null) => {
  if (status === 'active') return '#22c55e';
  if (status === 'low_activity') return '#eab308';
  if (status === 'inactive') return '#ef4444';
  return 'transparent';
};

export const WorkspaceWarningIcon = () => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      color: '#d97706',
      lineHeight: 1,
      flex: '0 0 auto'
    }}
    aria-hidden="true"
  >
    <svg width="13" height="12" viewBox="0 0 13 12">
      <path
        d="M6.5 1.2L12 11H1L6.5 1.2Z"
        fill="#facc15"
        stroke="#b45309"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      <rect x="6" y="4.4" width="1.1" height="3.4" rx="0.4" fill="#7c2d12" />
      <rect x="6" y="8.5" width="1.1" height="1.1" rx="0.4" fill="#7c2d12" />
    </svg>
  </span>
);

const UserStatusIcons = ({
  activityStatus,
  activityStatusTooltip,
  workspaceWarning,
  workspaceWarningTooltip
}: UserStatusIconsProps) => {
  const fill = circleColor(activityStatus);
  const isOutline = activityStatus === 'not_yet_installed';
  const activityLabel = activityStatusTooltip || 'User status';
  const warningLabel = workspaceWarningTooltip || 'Google Workspace warning';

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        minHeight: '18px'
      }}
    >
      <span
        title={activityLabel}
        aria-label={activityLabel}
        style={{
          width: '12px',
          height: '12px',
          borderRadius: '50%',
          display: 'inline-block',
          backgroundColor: isOutline ? '#ffffff' : fill,
          border: isOutline ? '2px solid #9ca3af' : `2px solid ${fill}`,
          boxSizing: 'border-box',
          flex: '0 0 auto'
        }}
      />
      {workspaceWarning ? (
        <span title={warningLabel} aria-label={warningLabel}>
          <WorkspaceWarningIcon />
        </span>
      ) : null}
    </span>
  );
};

export const StatusFilterIcon = ({ kind }: { kind: string }) => {
  if (kind === 'workspace_warning') return <WorkspaceWarningIcon />;
  if (kind === 'all') {
    return <span style={{ width: '12px', height: '12px', flex: '0 0 auto' }} />;
  }
  return (
    <UserStatusIcons
      activityStatus={kind === 'active' || kind === 'low_activity' || kind === 'inactive' || kind === 'not_yet_installed' ? kind : 'not_yet_installed'}
    />
  );
};

export default UserStatusIcons;
